<template>
    <div class="uncompleted-sorting">
        <h2 class="uncompleted-sorting__title" v-html="title"></h2>
        <NothingHereYet :content="getNothingHereYetText" :type="type" v-if="!hasAnyCourses" />
        <div class="uncompleted-sorting__container">
            <slot></slot>
            <TotemSelect
                v-if="hasAnyCourses"
                :options="orders"
                :placeholder="$t('CollectionFilter.from_new_to_old')"
                icon="filter"
                type="sorting"
                @input="selectSorter"
                :reduce="option => option.value"
                :value="sorting"
            />
        </div>
    </div>
</template>

<script>
    import NothingHereYet from 'components/user/shared/NothingHereYet'
    import userHubUncompletedCoursesSorting from 'components/shared/mixins/sorting/userHubUncompletedCoursesSorting'

    export default {
        components: { NothingHereYet },
        mixins: [
            userHubUncompletedCoursesSorting
        ],
        props: {
            uncompletedCourses: {
                type: Array,
                default: () => []
            },
            title: String,
            type: String
        },
        computed: {
            hasAnyCourses () {
                return this.uncompletedCourses.length > 0
            },
            getNothingHereYetText () {
                return this.type === 'courses' ? this.$t('UncompletedCoursesTab.no_courses') : this.$t('UncompletedCoursesTab.no_learning_paths')
            }
        }
    }
</script>

<style lang="scss" scoped>
.uncompleted-sorting {

    &__title {
        font-family: QuickSand-Bold, sans-serif;
        font-size: 2rem;
        margin: 0 0 20px;
    }

    &__description {
        display: block;
        max-width: 600px;
    }

    &__uncompleted-info {
        position: relative;
        top: 2px;
    }

    &__container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        gap: 30px;
        align-items: center;

        [class*="mobile_sm"] & {
            flex-direction: column;
            gap: 15px;
            margin-bottom: 15px;
        }
    }
}
</style>
